import moment from 'moment-timezone'
import Vue from 'vue'
import vueDebounce from 'vue-debounce'
import Vuelidate from 'vuelidate'
import './bootstrap'
import App from './main'
import Permissions from './mixins/permission'
import router from './router'
import store from './store'
import VCalendar from 'v-calendar'
import money from 'v-money'
import VueCurrencyFilter from 'vue-currency-filter'
import SvgVue from 'svg-vue'
// import VueHtmlToPaper from 'vue-html-to-paper'

import { asset } from '@codinglabs/laravel-asset'
import VueAgile from 'vue-agile'

let theme = await axios.get(`${process.env.MIX_ASSET_URL}/json/macarons.json`)

import { use, registerTheme } from 'echarts/core'
import { CanvasRenderer } from 'echarts/renderers'
import { PieChart, LineChart, BarChart, MapChart, RadarChart } from 'echarts/charts'
import {
  TitleComponent,
  VisualMapComponent,
  TooltipComponent,
  LegendComponent,
  GridComponent,
  GeoComponent,
  ToolboxComponent
} from 'echarts/components'
import ECharts from 'vue-echarts'
import 'echarts-gl'
import { Scatter3DChart } from 'echarts-gl/charts'
import { Grid3DComponent } from 'echarts-gl/components'

import 'leaflet/dist/leaflet.css'
import 'leaflet-geosearch/dist/geosearch.css'

use([
  CanvasRenderer,
  PieChart,
  BarChart,
  LineChart,
  MapChart,
  RadarChart,
  VisualMapComponent,
  TitleComponent,
  TooltipComponent,
  LegendComponent,
  GridComponent,
  GeoComponent,
  ToolboxComponent,
  Scatter3DChart,
  Grid3DComponent
])

registerTheme('macarons', theme.data)

// const options = {
//   name: '_blank',
//   specs: ['fullscreen=yes', 'titlebar=yes', 'scrollbars=yes'],
//   styles: ['https://cdn.jsdelivr.net/npm/bootstrap@5.3.6/dist/css/bootstrap.min.css'],
//   timeout: 1000,
//   autoClose: true,
//   windowTitle: window.document.title
// }

// Vue.use(VueHtmlToPaper, options)

Vue.component('v-chart', ECharts)

Vue.use(Vuelidate)
Vue.use(SvgVue)
Vue.use(VueAgile)

moment.tz.setDefault('Asia/Jakarta')
Vue.use(require('vue-moment'), {
  moment
})

Vue.use(vueDebounce, {
  listenTo: 'input',
  defaultTime: '500ms',
  fireOnEmpty: true
})

Vue.use(VCalendar)

Vue.mixin(Permissions)

Vue.mixin({
  methods: {
    asset: asset
  }
})

Vue.use(money, {
  decimal: ',',
  thousands: '.',
  prefix: '',
  suffix: '',
  precision: 0,
  masked: false
})

Vue.use(VueCurrencyFilter, [
  {
    // default name 'currency'
    symbol: 'Rp',
    thousandsSeparator: '.',
    fractionCount: 0,
    fractionSeparator: ',',
    symbolPosition: 'front',
    symbolSpacing: true,
    avoidEmptyDecimals: '--'
  },
  {
    name: 'numbFormat',
    symbol: '',
    thousandsSeparator: '.',
    fractionCount: 0,
    fractionSeparator: ',',
    symbolPosition: 'front',
    symbolSpacing: false,
    avoidEmptyDecimals: '--'
  }
])

import firebaseMessaging from './firebase'
Vue.prototype.$messaging = firebaseMessaging

Vue.config.productionTip = false

new Vue({
  router,
  store,
  el: '#app',
  render: h => h(App)
})
